{
  "title": "Memo",
  "actions": {
    "new": "Create memo",
    "newAndClear": "Create and clear",
    "reorderItem": "Drag to reorder {{headline}}",
    "selectAll": "Select all",
    "deselectAll": "Deselect all",
    "removeBlock": "Remove block",
    "removeItem": "Remove {{headline}}",
    "addBlock": "Add {{label}}",
    "insertDocument": "Insert {{title}}",
    "removeInsertedDocument": "Remove inserted {{title}}",
    "removeInsertedLine": "Remove the line {{text}}"
  },
  "labels": {
    "memo": "Memo",
    "selection": "Selection",
    "planningTitle": "Planning title",
    "assignmentTitle": "Assignment title",
    "memoTitle": "Memo title",
    "planningSlugline": "Planning slugline",
    "assignmentSlugline": "Assignment slugline",
    "dateFrom": "From date",
    "dateTo": "To date",
    "candidates": "Available items",
    "print": "Print articles",
    "planning": "Plannings",
    "article": "Articles",
    "events": "Events",
    "insertable": "Insert published memo",
    "chooseBlock": "Choose block",
    "insertSelectedInto": "Put selected in block",
    "unassignedCount": "{{count}} selected",
    "preview": "Preview",
    "keywordFor": "Keyword for {{headline}}",
    "noKeyword": "-"
  },
  "placeholders": {
    "template": "Choose template",
    "section": "Choose section",
    "memoSection": "Section for PM",
    "editorialInfoType": "Select editorial info-type",
    "newsvalue": "Newsvalue",
    "filterSection": "Section",
    "filterStory": "Story",
    "variant": "Choose days"
  },
  "errors": {
    "itemsRequired": "Choose items to create the memo",
    "sectionMissing": "The section {{section}} was not found",
    "sectionRequired": "Choose which section the memo is for",
    "templateRequired": "Choose a template to search for content"
  },
  "hints": {
    "draftOnly": "The memo is created as a draft. It is never published directly."
  },
  "banner": {
    "offline": "You are offline. Memos cannot be created until the connection is back."
  },
  "toasts": {
    "created": "Memo created"
  },
  "prompts": {
    "createSeveral": "You are about to create the following memos"
  }
}
